module.exports = __webpack_public_path__ + "img/banner1.1953ca12.jpg";